import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import homeLogo from "../../Assets/computer-monitor.png";
import Particle from "../Particle";
import HomeAbout from "./HomeAbout";
import Type from "./Type";
import { useTranslation } from 'react-i18next';
import "./Home.css";



function Home() {
  const { t } = useTranslation();

  return (
    <section className="home-container">
      <Container fluid className="home-section" id="home">
        <Particle/>
        <Container className="home-content">
          <Row>
            <Col md={7} className="home-header">
              <h1 style={{ paddingBottom: 15 }} className="heading">
                {t('hi')}{" "}
                <span className="wave" role="img" aria-labelledby="wave">
                  👋🏻
                </span>
              </h1> 

              <h1 className="heading-name">
              {t('im')}
                <strong className="main-name"> ADRIAN BAQUEIRO</strong>
              </h1>

              <div style={{ padding: 50, textAlign: "left" }}>
                <Type />
              </div>
            </Col>

            <Col md={5} style={{ paddingBottom: 20 }}>
              <img
                src={homeLogo}
                alt="home pic"
                className="img-fluid theme-img"
                style={{ maxHeight: "450px" }}
              />
            </Col>
          </Row>
        </Container>
      </Container>
      <HomeAbout />
    </section>
  );
}

export default Home;
